import { IRestfulApiService } from '@/lib/apiService'
import {
	CreateCopyrightByUserDTO,
	CreateCopyrightByUserResponseDTO,
	IMutationCommand,
} from '@bookips/solvook-api-shared'

/**
 * 저작권 침해내역 신고
 * @param dto CreateCopyrightByUserDTO
 * @returns Promise<CreateCopyrightByUserResponseDTO>
 */
export class CreateCopyrightByUserCommand
	implements IMutationCommand<any, CreateCopyrightByUserDTO, CreateCopyrightByUserResponseDTO>
{
	private apiService: IRestfulApiService
	constructor(apiService: IRestfulApiService) {
		this.apiService = apiService
	}

	execute(dto: CreateCopyrightByUserDTO): Promise<CreateCopyrightByUserResponseDTO> {
		const url = `/copyright`

		return this.apiService
			.fetch<CreateCopyrightByUserResponseDTO>(url, { method: 'POST', data: dto })
			.then((res) => res.data)
	}
}
